import { defaultTheme } from '@automata/mui-theme';
import { NumberField } from '@automata/ui';
import {
  Box,
  Button,
  Popover,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { MouseEvent, useCallback, useState } from 'react';

const styles = {
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: defaultTheme.palette.text.primary,
  },
} satisfies SxProps;

interface ParameterRangePopoverProps {
  decimal: boolean;
  min: number | null;
  max: number | null;
}

export const ParameterRangePopover = ({
  decimal,
  max,
  min,
}: ParameterRangePopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget),
    []
  );

  const handleClose = useCallback(() => setAnchorEl(null), []);

  return (
    <>
      <Button id="new-parameter" variant="text" onClick={handleClick}>
        Range
      </Button>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box>
          <Stack
            sx={{ p: 2 }}
            direction="column"
            justifyContent="center"
            alignItems="center"
            maxWidth={300}
          >
            <Typography variant="body1">
              Defines the acceptable values that can override the default.
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              <NumberField
                decimal={decimal}
                disabled={true}
                label="min value"
                value={min}
                sx={styles}
              />

              <NumberField
                decimal={decimal}
                disabled={true}
                label="max value"
                value={max}
                sx={styles}
              />
            </Stack>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};
